import React from "react";
import {MenuItem, MenuSection} from "../../layout/menu/MenuItems";
import {useIntl} from "react-intl";
import DashboardLink from "./DashboardLink";

const DashboardLinksSection = ({name, items}: MenuSection) => {
    const intl = useIntl();

    return (
        <div className={"w-full flex flex-col gap-3 xl:gap-3"}>
            {
                name &&
                <span className={"inline-block text-sm font-semibold text-black/60 dark:text-white/60"}>
                    {name(intl)}
                </span>
            }

            <div className={"w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-6"}>
                {items
                    .filter(x => !x.excludeInParentOverview)
                    .map((item: MenuItem, i: number) =>
                        <DashboardLink key={i} {...item}/>
                    )}
            </div>
        </div>
    );
};

export default DashboardLinksSection;